import React, { useState } from "react";
import {
  Title,
  GoBack,
  Message,
  TextArea,
  InputField,
  ActionButton,
} from "../../component/Component";
import { codeOk, errorMessage } from "../../../../middlewares/index";
import { useReligionContext } from "../../../../context/religion/ReligionContext";
import { getOneReligion } from "../../../../middlewares/sysNavigation/SysNavigation";

const Edit = () => {
  const { updateReligionState, updateReligion } = useReligionContext();

  const religion = getOneReligion();

  let [error, setError] = useState(false);
  let [status, setStatus] = useState(0);
  let [message, setErrorMessage] = useState("");
  let [loading, setLoading] = useState(false);
  let [success, setSuccess] = useState(false);

  const religion_id = religion.religion_id;

  const [name, setName] = useState(religion.name);
  const [description, setDescription] = useState(religion.description);

  const religionRoutes = "/religion";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
  };

  const responses = (isError, status, message) => {
    setError(isError);
    setStatus(status);
    setErrorMessage(message);
  };

  const updateOneReligionHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = { name, description };

    const response = await updateReligion(religion_id, data);
    if (response) {
      if (response.data.status === codeOk) {
        updateReligionState({ religion_id, ...data });
        cleanFields();
        return responses(true, response.data.status, response.data.message);
      } else {
        setLoading(false);
        return responses(true, response.data.status, response.data.message);
      }
    } else {
      setLoading(false);
      return responses(true, 400, errorMessage);
    }
  };

  return (
    <div className="h-full overflow-y-auto bg-gray-50 p-4 lg:p-6">
      <div className="mx-auto max-w-4xl">
        {/* Top bar */}
        <div className="mb-4 flex items-center justify-between">
          <GoBack props={{ route: religionRoutes }} />
          <span className="hidden rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700 sm:inline-flex">
            Editing
          </span>
        </div>

        {/* Alerts */}
        <div className="mb-4">
          <Message
            props={{
              error,
              success,
              message,
              loading,
              status,
              onClick: () => {
                setError(false);
                setSuccess(false);
                setErrorMessage("");
              },
            }}
          />
        </div>

        {/* Form card */}
        <form onSubmit={updateOneReligionHandler}>
          <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
            {/* Card header */}
            <div className="flex items-center justify-between px-6 py-5">
              <div className="flex items-center gap-3">
                <span className="grid h-10 w-10 place-items-center rounded-xl bg-indigo-100 text-indigo-600">
                  <svg
                    viewBox="0 0 24 24"
                    className="h-5 w-5"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M4 5a2 2 0 0 1 2-2h7a3 3 0 0 1 3 3v12a1 1 0 0 1-1.447.894L12 17.118l-2.553 1.776A1 1 0 0 1 8 18V6H6a2 2 0 0 1-2-1Z" />
                    <path d="M18 4h1a1 1 0 0 1 1 1v13.5a1.5 1.5 0 0 1-2.414 1.2L16 18.5V6a2 2 0 0 1 2-2Z" />
                  </svg>
                </span>
                <div>
                  <h1 className="text-base font-semibold leading-tight text-gray-900">
                    Edit Religion
                  </h1>
                  <p className="mt-0.5 text-xs text-gray-600">
                    Update the name and description, then save your changes.
                  </p>
                </div>
              </div>
            </div>

            <div className="border-t border-gray-100" />

            {/* Card body */}
            <div className="px-6 py-6">
              <div className="mb-3">
                <Title props={{ title: "Religion Details" }} />
              </div>

              <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                <InputField
                  props={{
                    id: "title",
                    title: "Name",
                    type: "text",
                    required: true,
                    value: name ? name : "",
                    onChange: (e) => {
                      setName(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
                <div className="md:col-span-2">
                  <TextArea
                    props={{
                      id: "description",
                      title: "Description",
                      type: "text",
                      required: true,
                      value: description ? description : "",
                      onChange: (e) => {
                        setDescription(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="border-t border-gray-100" />

            {/* Card footer */}
            <div className="flex justify-end px-6 py-5">
              <ActionButton
                props={{
                  title: `Save Changes`,
                  error,
                  success,
                  message,
                  loading,
                  status,
                  onClick: () => {
                    setError(false);
                    setSuccess(false);
                    setErrorMessage("");
                  },
                }}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Edit;
